import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { DEFAULT_BG } from '../../utils/heroRandomBgColor';
import TrustedBy from './TrustedBy';
import Header from './Header';
import HeroImages from './HeroImages';
import { heroCompaniesImages } from './config';

import './style.scss';

const Hero = ({ bgColor = DEFAULT_BG }) => {
    const backgroundClassname  = classNames('hero-background', bgColor);

    return (
        <div className="hero">
            <div className="hero-main-wrapper">
                <div className={backgroundClassname}/>
                <div className="hero-main">
                    <Header/>
                    <HeroImages/>
                </div>
            </div>
            <ul className="trusted-by">
                {
                    heroCompaniesImages.map((company, index) => (
                        <TrustedBy key={index} company={company}/>
                    ))
                }
            </ul>
        </div>
    );
};

Hero.propTypes = {
    bgColor: string
};

export default Hero;
